import React from "react";
import { AlertTriangle } from "lucide-react";
import { STATE_RESOURCES } from "@/lib/states";

export default function Disclaimer({ compact = false, state }) {
 const links = STATE_RESOURCES[state] || STATE_RESOURCES.QLD;

 if (compact) {
 return (
 <div className="text-xs text-[#6B7280] italic border-t border-[#E5E4DE] pt-3 mt-3 font-serif" data-testid="disclaimer-compact">
 General information only. not legal advice. For advice contact{" "}
 {links.map(([name, url], i) => (
 <React.Fragment key={url}>
 <a href={url} target="_blank" rel="noreferrer" className="text-[#0D2B52] underline-offset-2 hover:underline">{name}</a>
 {i < links.length - 1 ? " · " : "."}
 </React.Fragment>
 ))}
 </div>
 );
 }

 return (
 <div className="card border-[#B35D4C]/30 bg-[#B35D4C]/[0.03]" data-testid="disclaimer-full">
 <div className="flex gap-3">
 <AlertTriangle size={20} strokeWidth={1.5} className="text-[#B35D4C] mt-0.5 flex-shrink-0" />
 <div>
 <h4 className="font-serif text-lg text-[#1A1A1A] mb-1">This is not legal advice</h4>
 <p className="text-sm text-[#333] leading-relaxed">
 TenantTrail provides general legal information and helps you organise your tenancy documents.
 It is not a substitute for advice from a qualified solicitor. If your matter is serious,
 please contact one of the following free services:
 </p>
 <ul className="mt-3 space-y-1.5 text-sm">
 {links.map(([name, url]) => (
 <li key={url}>
 · <a href={url} target="_blank" rel="noreferrer" className="text-[#0D2B52] hover:underline font-medium">{name}</a>
 </li>
 ))}
 </ul>
 </div>
 </div>
 </div>
 );
}
